export { HasAccessForPlatformQuery } from './has-access-for-platform';
